<template>
  <div class="editPage" v-loading="subLoading">
    <qx-card :title="contentTitle">
      <BaseForm ref="baseForm" @getOtherFormVal="getOtherFormVal" />
      <Insurance ref="insurance" @getOtherFormVal="getOtherFormVal" />
      <Receipt ref="receipt" />
      <!-- <Other ref="other" @getOtherFormVal="getOtherFormVal" /> -->
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import Receipt from './receipt';
import Insurance from './insurance';
// import Other from './other';
import SubBtnBox from 'components/subBtnBox';
import {
  saveOrUpdateOaLoan,
  borrowDetail,
} from 'api/cost';
import {
  getEnumList,
} from 'api';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    Insurance,
    Receipt,
    // Other,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/cost/borrow/manage/edit',
      formComponents: ['baseForm', 'insurance', 'receipt',
        // , 'other'
      ],
      enumsList: [],

      subLoading: false,
      // 需要对比的参数
      compareParams: {
        amount: '',
        orderId: '',
        loanSubject: '',
        plateNumber: '',
        carOwnerName: '',
        weight: '',
        carPhone: '',
        appReason: '',
        fileId: [],

        borrowUserId: '',
      },
    };
  },
  computed: {
    detailParams () {
      return {
        LId: this.$route.query.id,
      };
    },
    contentTitle () {
      let title = '借支管理';
      if (this.$route.query.loanType === '1') {
        title = '司机出车借支';
      } else if (this.$route.query.loanType === '2') {
        title = '车辆维护借支';
      } else if (this.$route.query.loanType === '3') {
        title = '员工借支';
      }
      return title;
    },
  },
  watch: {
    '$route.query.loanType': {
      handler (newValue) {
        if (newValue) {
          this.setLoanSubject(newValue);
        }
      },
      immediate: true,
    },
  },
  methods: {
    detailApi: borrowDetail,
    editApi: saveOrUpdateOaLoan,

    // 处理对比参数
    adjustCompareParams (compareParams) {
      compareParams.receUserId = compareParams.borrowUserId;

      if (compareParams.fileId.length) {
        compareParams.fileId = compareParams.fileId.join(',');
      } else {
        compareParams.fileId = '';
      }

      if (compareParams.loanSubject && Array.isArray(compareParams.loanSubject)) {
        // 因为组件的 init 方法改变了原始数据的格式，这里又得把格式转回来，为了方便后面的数据对比
        compareParams.loanSubject = compareParams.loanSubject.join(',');
      }
    },
    async getOtherFormVal ({ from, tar }) {
      const tarFormData = await this.$refs[tar].cacheData();
      if (this.$refs[from] && this.$refs[from].receiveData) {
        this.$refs[from].receiveData(tar, tarFormData);
      }
    },
    setLoanSubject (loanType) {
      if (this.enumsList && this.enumsList.length) {
        const enumsList = JSON.parse(JSON.stringify(this.enumsList));
        const loanSubjectAllOptions = enumsList[0];
        if (loanSubjectAllOptions && loanSubjectAllOptions.length) {
          // 通过 codeId 区分列表，3：司机出车借支/车辆维护借支  4.员工借支
          let loanSubjectNewOptions = [];
          if (loanType === '1' || loanType === '2') {
            loanSubjectAllOptions.forEach((item) => {
              if (item.codeId === 3) {
                loanSubjectNewOptions.push(item);
              }
            });
          }
          if (loanType === '3') {
            loanSubjectAllOptions.forEach((item) => {
              if (item.codeId === 4) {
                loanSubjectNewOptions.push(item);
              }
            });
          }
          this.$nextTick(() => {
            enumsList[0] = loanSubjectNewOptions;
            this.$refs.baseForm.setList(enumsList);
          });
        }
      }
    },
  },
  async mounted () {
    const enumsList = await getEnumList({
      codeType: 'LOAN_SUBJECT,IS_NEED_BILL_OA,LOAN_ACCIDENT_TYPE,LOAN_ACCIDENT_REASON,LOAN_DUTY_DIVIDE,LOAN_ACCIDENT_DRIVER',
    });
    this.enumsList = enumsList;
    this.setLoanSubject(this.$route.query.loanType);
    this.$nextTick(() => {
      this.$refs.insurance.setList(enumsList);
    });
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
